<template>
  <projectDetails1 :pulldata="data" v-if="bid == 1"></projectDetails1>
  <projectDetails2 :pulldata="data" v-else-if="bid == 2"></projectDetails2>
</template>
<script>
import {
  projectdetail,
} from "@/api/course";

import projectDetails1 from "@/views/course/project_details/project_details1"
import projectDetails2 from "@/views/course/project_details/project_details2"

export default {
  data() {
      return {
        cid: null,
        data: {},
        bid: ''
      }
    },
    components: {
      projectDetails1,
      projectDetails2
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let querys = this.$route.query;
        this.cid = querys.cid;
        projectdetail({
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid,
            pdk: this.$route.query.pdk ? this.$route.query.pdk : '',
            aspx: this.$route.query.aspx ? this.$route.query.aspx : "",
          })
          .then((data) => {
            this.$toast.clear();
            if (typeof data === "string") {
              let index = data.lastIndexOf('/');
              let x = data.substring(index);
              this.$router.push(x);
              return;
            };
            this.data = data;
            this.bid = data.bid;
          })
      }
    },
    created() {
      this.pullData();
    },
}
</script>